module.exports = __webpack_public_path__ + "static/media/yt.655a17fe.svg";